import { useState } from "react";
import addicon from "../../../../../assets/shapes_svg/ambition/actionplans/add-icon.svg";
import { useUserAccess } from "../../../../../components/WriteAccessContext";

const AddEffortButton = ({ className, handleSave, newName, setNewName }) => {
  const [isEdit, setIsEdit] = useState(false);
  const { userAccess } = useUserAccess();
  return (
    <div
      className={className}
      style={{
        maxHeight: "max-content",
        gap: "11px",
      }}
    >
      {" "}
      {isEdit && userAccess === "write" ? (
        <input
          type="text"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          onBlur={() => {
            handleSave(newName);
            setIsEdit(!isEdit);
          }}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              handleSave(newName);
              setIsEdit(!isEdit);
            }
          }}
          autoFocus
          style={{
            background: "transparent",
            border: "none",
            outline: "none",
            color: "white",
            padding: "5px",
          }}
        />
      ) : (
        <div
          onClick={() => setIsEdit(!isEdit)}
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            gap: "8px",
            padding: "0 8px",
          }}
        >
          <img src={addicon} alt="Add icon" width={50} height={50} />
          <h5>Add Effort</h5>
        </div>
      )}
    </div>
  );
};

export default AddEffortButton;
